import { iffApi } from "../../../services/api";

type ApprovedFeedstockResponse = {
  rows: any[],
  count: number
}

const approvedFeedstockApi = iffApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovedFeedstock: builder.query<any, void>({
      query: () => "approved-feedstocks/",
      transformResponse: (response: ApprovedFeedstockResponse) => response.rows
    }),
  }),
  overrideExisting: false,
});

export const { useGetApprovedFeedstockQuery } = approvedFeedstockApi;